import React, { useState, useEffect } from "react";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import ReactTooltip from "react-tooltip";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";
import MultiSelectInput from "../../../components/MultiSelectInput";
import { useStates } from "../hooks/useStates";
import { useGetProducerCodeListByCarrierId } from "./hooks/useGetProdCodeByCarrierId";
import useGetEmployees from "./hooks/useGetEmployees";
const ProdCodeFormLOBSection = ({
  handleMACheckBox,
  tableName,
  masterCarrierId,
  state,
  handleProducerCodeInputs,
  carrierProducerCodeData,
  distChannelOpts,
  addMainForm,
  mgaOpt,
  cProgramOpt,
  prodtypeoptions,
  employeeOpts,
  employeeFranchiseOpts,
  isChannelFranchise,
  rowId,
  row,
  rowIsFranchise,
  rowIsClearDropdowns,
  isResetCarrierDependency,
  loboptions,
  empFranchisesOpts,
  empConfieOpts,
}) => {
  const user = useRecoilValue(accountAtom);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const { data: employeeList } = useGetEmployees();
  const [selectedProgram, setSelectedProgram] = useState([]);
  const [selectedMasterCode, setSelectedMasterCode] = useState([]);
  const [selectedRollUpCode, setSelectedRollUpCode] = useState([]);
  const [selectedState, setSelectedStates] = useState([]);
  const data = carrierProducerCodeData?.ProducerCodes
    ? carrierProducerCodeData?.ProducerCodes
    : carrierProducerCodeData;
  const { data: allProducerCodeListByCarrier } =
    useGetProducerCodeListByCarrierId(carrierProducerCodeData?.MasterCarrierId);
  const masterCodesOpts = allProducerCodeListByCarrier?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
      isActive: x.isActive,
      isFranchise: x.isFranchise,
    };
  });
  const rollUpCodesOps = allProducerCodeListByCarrier?.map((x) => {
    return {
      label: x.producerCodes + " - " + x.officeName,
      value: x.carrierProducerCodeId,
      isActive: x.isActive,
      isFranchise: x.isFranchise,
    };
  });
  const { data: states } = useStates();
  const allStatesOpt = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });

  const codeStatus = [
    { label: "Active", value: true },
    {
      label: "Inactive",
      value: false,
    },
  ];

  useEffect(() => {
    //Changing Franchise Value
    if (rowIsClearDropdowns) {
      setSelectedEmployee([]);
      setSelectedStates([]);
      setSelectedMasterCode([]);
      setSelectedRollUpCode([]);
    }
    //Changing Carrier Value
    if (isResetCarrierDependency) {
      setSelectedProgram([]);
      setSelectedMasterCode([]);
      setSelectedRollUpCode([]);
    }
  }, [rowIsClearDropdowns, isResetCarrierDependency]);
  const handleMultiIssuedToSelect = (
    tableName,
    columnName,
    checkedEmp,
    masterCarrierId,
    state,
    rowIds,
    prodRowId,
    addMainForm
  ) => {
    var empList = [];
    if (columnName === "IssuedTo") {
      checkedEmp.map((x) => {
        empList.push(x.value);
      });
      handleProducerCodeInputs(
        tableName,
        columnName,
        empList,
        masterCarrierId,
        state,
        rowIds,
        prodRowId,
        addMainForm
      );
      setSelectedEmployee(checkedEmp);
    }
    if (columnName === "CrossSale") {
      checkedEmp.map((x) => {
        empList.push(x.value);
      });
      handleProducerCodeInputs(
        tableName,
        columnName,
        empList,
        masterCarrierId,
        state,
        rowIds,
        prodRowId,
        addMainForm
      );
      setSelectedStates(checkedEmp);
    }
  };
  return (
    <div className="bg-backgroundExpanded">
      <div className="w-full px-4 py-5">
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full">
          {/* <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                  } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="block w-full text-gray-700 expandedLabel fontExpand mb-1">
                    Sub Code:
                  </label>
                )}
              </div>
            </div>
            <div>
              <TextInput
                value={data.map((x) => x.ProducerSubCode)[rowId - 1]}
                inputTextHeight={"h-7"}
                onChange={(e) => {
                  handleProducerCodeInputs(
                    tableName,
                    "producerSubCode",
                    e.target.value,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
                onKeyPress={(event) => {
                  if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div> */}
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    {<span className="text-red-500">*</span>} Line of Business:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={
                  loboptions.filter((l) => l.value === row.LineOfBusiness)[0]
                }
                // value={newLob}
                options={loboptions}
                onChange={(selectedOptions) => {
                  handleProducerCodeInputs(
                    tableName,
                    "lineOfBusiness",
                    selectedOptions ? selectedOptions.value : null,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
              />
            </div>
          </div>{" "}
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full   text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    {<span className="text-red-500">*</span>} Producer Code
                    Type:{" "}
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={
                  prodtypeoptions?.filter(
                    (l) =>
                      l.value === data.map((x) => x.ProducerCodeType)[rowId - 1]
                  )[0]
                }
                options={prodtypeoptions}
                onChange={(selectedOptions) => {
                  handleProducerCodeInputs(
                    tableName,
                    "ProducerCodeType",
                    selectedOptions ? selectedOptions.value : null,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
              />
            </div>
          </div>{" "}
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                <label className="w-full block text-gray-700 expandedLabel fontExpand">
                  M&A:{" "}
                  {data.map((x) => x.isMA)[rowId - 1] && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
              </div>
            </div>
            <div className="flex flex-row items-center gap-2">
              <div className="flex items-center justify-center space-x-1 cursor-pointer mb-1 pt-1 w-auto">
                <ReactTooltip id="M&A" place="top" effect="solid" type="info" />
                <input
                  data-tip={
                    !data.map((x) => x.isMA)[rowId - 1]
                      ? "Check if M&A!"
                      : "Uncheck if not M&A!"
                  }
                  data-for="M&A"
                  type="checkbox"
                  className="ml-1 w-5 h-5 bg-white shadow cursor-pointer"
                  defaultChecked={data.map((x) => x.isMA)[rowId - 1]}
                  onClick={(e) => {
                    handleMACheckBox(e, row);
                  }}
                />
              </div>
              <label
                className="cursor-pointer text-gray-700 fontExpand expandedLabel"
                name="M&A"
              >
                {data.map((x) => x.isMA)[rowId - 1] && (
                  <div>
                    <TextInput
                      className="-ml-1"
                      placeholder="Producer Code"
                      defaultValue={
                        data.map((x) => x.maProducerCodes)[rowId - 1]
                      }
                      inputTextHeight={"h-7"}
                      onChange={(e) =>
                        handleProducerCodeInputs(
                          tableName,
                          "M&A",
                          e.target.value,
                          masterCarrierId,
                          state,
                          data.map((x) => x.RowId)[rowId - 1],
                          data.map((x) => x.producerCodeRowId)[rowId - 1] ==
                            null
                            ? 1
                            : data.map((x) => x.producerCodeRowId)[rowId - 1],
                          addMainForm
                        )
                      }
                      onKeyPress={(event) => {
                        if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                )}
              </label>
            </div>
          </div>
        </div>
        {/* 2nd Row */}
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full">
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Issued To:
                  </label>
                )}
              </div>
            </div>
            <div>
              {/* {user.isFranchise && user.isNonFranchise ? ( */}
              {
                isChannelFranchise ? (
                  <>
                    <MultiSelectInput
                      options={employeeList
                        ?.filter(
                          (x) =>
                            x.status !== "Terminated" &&
                            x.employeeTypeName === "Franchise" &&
                            x.employeenumber !== null
                        )
                        .map((x) => {
                          return {
                            label: x.fullname + " - " + x.employeenumber,
                            value: x.employeeId,
                          };
                        })}
                      value={selectedEmployee}
                      handleMultiSelect={(selectedOptions) =>
                        handleMultiIssuedToSelect(
                          tableName,
                          "IssuedTo",
                          selectedOptions,
                          masterCarrierId,
                          state,
                          data.map((x) => x.RowId)[rowId - 1],
                          data.map((x) => x.producerCodeRowId)[rowId - 1] ===
                            null
                            ? 1
                            : data.map((x) => x.producerCodeRowId)[rowId - 1],
                          addMainForm
                        )
                      }
                    />
                  </>
                ) : (
                  <>
                    <MultiSelectInput
                      options={employeeList
                        ?.filter(
                          (x) =>
                            x.status !== "Terminated" &&
                            x.employeeTypeName !== "Franchise" &&
                            x.employeenumber !== null
                        )
                        .map((x) => {
                          return {
                            label: x.fullname + " - " + x.employeenumber,
                            value: x.employeeId,
                          };
                        })}
                      value={selectedEmployee}
                      handleMultiSelect={(selectedOptions) =>
                        handleMultiIssuedToSelect(
                          tableName,
                          "IssuedTo",
                          selectedOptions,
                          masterCarrierId,
                          state,
                          data.map((x) => x.RowId)[rowId - 1],
                          data.map((x) => x.producerCodeRowId)[rowId - 1] ===
                            null
                            ? 1
                            : data.map((x) => x.producerCodeRowId)[rowId - 1],
                          addMainForm
                        )
                      }
                    />
                  </>
                )
                // ) : (
                //   <>
                //     <MultiSelectInput
                //       options={employeeOpts
                //         ?.filter(
                //           (x) =>
                //             x.status !== "Terminated" && x.employeeId !== null
                //         )
                //         ?.map((x) => {
                //           return {
                //             label: x.fullname + " - " + x.employeenumber,
                //             value: x.employeeId,
                //             fullname: x.fullname,
                //           };
                //         })}
                //       value={selectedEmployee}
                //       handleMultiSelect={(selectedOptions) =>
                //         handleMultiIssuedToSelect(
                //           tableName,
                //           "IssuedTo",
                //           selectedOptions,
                //           masterCarrierId,
                //           state,
                //           data.map((x) => x.RowId)[rowId - 1],
                //           data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                //             ? 1
                //             : data.map((x) => x.producerCodeRowId)[rowId - 1],
                //           addMainForm
                //         )
                //       }
                //     />
                //   </>
                // )
              }
            </div>
          </div>
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full  text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    MGA:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={
                  mgaOpt &&
                  mgaOpt
                    .map((x) => {
                      return { value: x.id, label: x.mga1 };
                    })
                    .filter(
                      (l) => l.value === data.map((x) => x.MGA)[rowId - 1]
                    )[rowId]
                }
                options={
                  mgaOpt &&
                  mgaOpt.map((x) => {
                    return { value: x.id, label: x.mga1 };
                  })
                }
                onChange={(selectedOptions) => {
                  handleProducerCodeInputs(
                    tableName,
                    "mga",
                    selectedOptions ? selectedOptions.value : null,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
              />
            </div>
          </div>
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Carrier Program Name:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={selectedProgram}
                isDisabled={!carrierProducerCodeData.MasterCarrierId}
                options={
                  cProgramOpt.data &&
                  cProgramOpt.data
                    .filter(
                      (x) =>
                        x.carrierId ===
                          carrierProducerCodeData.MasterCarrierId &&
                        x.isActive === true
                    )
                    .map((x) => {
                      return { value: x.id, label: x.programName };
                    })
                }
                onChange={(selectedOptions) => {
                  setSelectedProgram(selectedOptions);
                  handleProducerCodeInputs(
                    tableName,
                    "program",
                    selectedOptions ? selectedOptions.value : null,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
              />
            </div>
          </div>
        </div>
        {/* 3rd Row */}
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full ">
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Can Sell:
                  </label>
                )}
              </div>
            </div>
            <div>
              <>
                <MultiSelectInput
                  options={allStatesOpt}
                  value={selectedState}
                  handleMultiSelect={(selectedOptions) =>
                    handleMultiIssuedToSelect(
                      tableName,
                      "CrossSale",
                      selectedOptions,
                      masterCarrierId,
                      state,
                      data.map((x) => x.RowId)[rowId - 1],
                      data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                        ? 1
                        : data.map((x) => x.producerCodeRowId)[rowId - 1],
                      addMainForm
                    )
                  }
                />
              </>
            </div>
          </div>
        </div>
        {/* 4th Row */}
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full ">
          <div className="w-full grid grid-cols-2 items-center space-y-2"></div>
          <div className="w-full grid grid-cols-2 items-center">
            <div className="w-full grid grid-cols-1 items-center"></div>
          </div>
          <div className="w-full grid grid-cols-2 items-center">
            <div className="w-full grid grid-cols-1 items-center"></div>
          </div>
        </div>
      </div>
      <div className="border-t space-y-2"></div>
      <div className="w-full px-4 py-5">
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full">
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Master Code Status:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                isClearable={false}
                value={
                  codeStatus?.filter(
                    (l) =>
                      l.value === data.map((x) => x.MasterCodeStatus)[rowId - 1]
                  )[0]
                }
                options={codeStatus}
                onChange={(selectedOptions) => {
                  handleProducerCodeInputs(
                    tableName,
                    "masterCodeStatus",
                    selectedOptions?.value ? selectedOptions?.value : false,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm
                  );
                }}
                isClearable={false}
              />
            </div>
          </div>
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Roll Up Code Status:
                  </label>
                )}
              </div>
            </div>
            <div>
              <div>
                <SelectInput
                  isClearable={false}
                  value={
                    codeStatus?.filter(
                      (l) =>
                        l.value ===
                        data?.map((x) => x.RollUpCodeStatus)[rowId - 1]
                    )[0]
                  }
                  options={codeStatus}
                  onChange={(selectedOptions) => {
                    handleProducerCodeInputs(
                      tableName,
                      "rollUpCodeStatus",
                      selectedOptions?.value ? selectedOptions?.value : false,
                      masterCarrierId,
                      state,
                      data.map((x) => x.RowId)[rowId - 1],
                      data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                        ? 1
                        : data.map((x) => x.producerCodeRowId)[rowId - 1],
                      addMainForm
                    );
                  }}
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="w-full grid grid-cols-2 items-center">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2"></div>
            <div></div>
          </div>{" "}
        </div>
        {/* 5th Row */}
        <div className="text-xs grid grid-cols-3 items-start gap-x-4 gap-y-4 w-full">
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Master Code:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={selectedMasterCode}
                options={masterCodesOpts?.filter(
                  (x) => x.isFranchise === rowIsFranchise
                )}
                onChange={(selectedOptions) => {
                  setSelectedMasterCode(selectedOptions);
                  handleProducerCodeInputs(
                    tableName,
                    "masterCode",
                    selectedOptions ? selectedOptions.label : null,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm,
                    selectedOptions?.isActive
                  );
                }}
                isDisabled={
                  carrierProducerCodeData?.MasterCarrierId ? false : true
                }
              />
            </div>
          </div>
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2">
              <div
                className={`${
                  data.map((x) => x.producerCodeRowId)[0] === 1 && ""
                } w-full text-xs`}
              >
                {data.map((x) => x.producerCodeRowId)[0] === 1 && (
                  <label className="w-full block text-gray-700 expandedLabel fontExpand">
                    Roll Up Code:
                  </label>
                )}
              </div>
            </div>
            <div>
              <SelectInput
                value={selectedRollUpCode}
                options={rollUpCodesOps?.filter(
                  (x) => x.isFranchise === rowIsFranchise
                )}
                onChange={(selectedOptions) => {
                  setSelectedRollUpCode(selectedOptions);
                  handleProducerCodeInputs(
                    tableName,
                    "rollUpCode",
                    selectedOptions?.value ? selectedOptions.value : 0,
                    masterCarrierId,
                    state,
                    data.map((x) => x.RowId)[rowId - 1],
                    data.map((x) => x.producerCodeRowId)[rowId - 1] === null
                      ? 1
                      : data.map((x) => x.producerCodeRowId)[rowId - 1],
                    addMainForm,
                    selectedOptions?.isActive
                  );
                }}
                isDisabled={
                  carrierProducerCodeData?.MasterCarrierId ? false : true
                }
              />
            </div>
          </div>{" "}
          <div className="w-full grid grid-cols-2 items-center space-y-2">
            <div className="flex justify-end space-x-1 text-left mr-2 pt-2"></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProdCodeFormLOBSection;
